import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';

import { NavbarBrand, NavbarToggle, NavbarCollapse, Navbar, Nav, Container } from '@/components/wrapped';
import DataNavDropdown from '@/components/layout/DataNavDropdown';
import ServicesNavDropdown from '@/components/layout/ServicesNavDropdown';
import AboutNavDropdown from '@/components/layout/AboutNavDropdown';

import styles from '@/styles/Navigation.module.scss';

type NavLinkProps = {
  active: boolean
  href: string
  children?: React.ReactNode
}


function NavLink({ active, href, children }: NavLinkProps) {
  const clazz = classNames("nav-link", styles.navItem, { [styles.active]: active });
  return <Link className={clazz} href={href} prefetch={false}>{children}</Link>
}


type NavbarSectionProps = {
  activeSection?: string
}

export default function Navigation({ activeSection }: NavbarSectionProps) {
  return (
    <Navbar expand="lg" className={styles.navBar} role="banner">
      <Container className={styles.navContainer}>
        <Link href="/" prefetch={false} passHref>
          <NavbarBrand>
            <img
              src="https://assets.opensanctions.org/images/nura/logo-oneline-color.svg"
              width="190"
              height="30"
              className="align-top"
              alt="OpenSanctions"
            />
          </NavbarBrand>
        </Link>
        <NavbarToggle className={styles.navToggle} />
        <NavbarCollapse className="justify-content-end">
          <Nav
            className={classNames("justify-content-end", styles.nav)}
            variant="pills"
            role="navigation"
            aria-label="Site menu"
          >
            <DataNavDropdown active={activeSection === 'data'} />
            <ServicesNavDropdown active={activeSection === 'services'} />
            <NavLink href="/docs/" active={activeSection === 'docs'}>Documentation</NavLink>
            <AboutNavDropdown active={activeSection === 'about'} />
          </Nav>
        </NavbarCollapse>
      </Container>
    </Navbar >
  )
}
